import * as React from 'react';
import { createContext, useContext } from 'react';

import type { SearchExplainQueryMetrics } from 'bundles/search-common/components/internal-search-explainer/types';

type SearchExplainContextValue = {
  hasPermission: boolean;
  enableSearchExplain: boolean;
  toggleSearchExplain: () => void;
  queryMetrics: SearchExplainQueryMetrics | null;
  metricsLoading: boolean;
  metricsError?: Error;
};

const SearchExplainContext = createContext<SearchExplainContextValue | undefined>(undefined);

type SearchExplainProviderProps = {
  children: React.ReactNode;
  value: SearchExplainContextValue;
};

export const SearchExplainProvider = ({ children, value }: SearchExplainProviderProps) => {
  return <SearchExplainContext.Provider value={value}>{children}</SearchExplainContext.Provider>;
};

export const useSearchExplain = () => {
  const context = useContext(SearchExplainContext);
  if (context === undefined) {
    throw new Error('useSearchExplain must be used within a SearchExplainProvider');
  }
  return context;
};

export default SearchExplainContext;
